import axios from 'axios';
import { FilemakerCreateContact } from '@resources/scripts/models';

export const createContact = async (submission: FilemakerCreateContact) => axios.post('/api/contacts', submission);
export const queryContacts = async (queryModel, pageSize = 5, currentPage = 1) => axios.post(`/api/contacts/query/paged?pageSize=${pageSize}&currentPage=${currentPage}`, queryModel);
export const queryFirstContact = async queryModel => axios.post('/api/contacts/query/first', queryModel);
export const updateContact = async (contactId: string, submission: FilemakerCreateContact) => axios.patch(`/api/contacts/${contactId}`, submission);

export default {
  createContact,
  queryContacts,
  queryFirstContact,
  updateContact,
};